import { create } from 'zustand';

export type CurrencyInfo = {
  id: number | string;
  iso: string;
  name: string | null;
  rate: number;
  primary: boolean;
};

type WindowCurrencyData = {
  primaryIso: string;
  currencies: CurrencyInfo[];
  rates: Record<string, number>;
};

declare global {
  interface Window {
    __currencyData?: WindowCurrencyData;
  }
}

export type CurrenciesState = {
  primaryIso?: string;
  currencies: CurrencyInfo[];
  rates: Record<string, number>;
  selectedIso?: string;
  setSelectedIso: (iso?: string) => void;
  initFromWindow: (data?: WindowCurrencyData) => void;
  reset: () => void;
};

export const useCurrenciesStore = create<CurrenciesState>((set) => ({
  primaryIso: undefined,
  currencies: [],
  rates: {},
  selectedIso: undefined,
  setSelectedIso: (iso) => set(() => ({ selectedIso: iso })),
  initFromWindow: (data?: WindowCurrencyData) =>
    set((state) => {
      const src = data || (typeof window !== 'undefined' ? window.__currencyData : undefined);
      if (!src) return state;
      // Prefer previously selected if still present; else default to primary
      const selected = state.selectedIso && src.rates[state.selectedIso] !== undefined
        ? state.selectedIso
        : src.primaryIso;
      return {
        primaryIso: src.primaryIso,
        currencies: src.currencies || [],
        rates: src.rates || {},
        selectedIso: selected,
      } as Partial<CurrenciesState> as CurrenciesState;
    }),
  reset: () => set(() => ({ primaryIso: undefined, currencies: [], rates: {}, selectedIso: undefined })),
}));
